import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { clientTemplate, employeeTemplate, functionpermission, onBoardingtemplateBO } from './agreement-template.model';
import { AgreementTemplateService } from './agreement-template.service';

@Component({
  selector: 'app-agreement-template',
  templateUrl: './agreement-template.component.html',
  styleUrls: ['./agreement-template.component.scss']
})

export class AgreementTemplateComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridEmp') public gridEmp: GridComponent;

  public pageSettings: PageSettingsModel;
  public filterOption: object;
  public data: any;
  gridData: any;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];

  private onDestroy$: Subject<void> = new Subject<void>();
  gridTemplateBO: onBoardingtemplateBO = new onBoardingtemplateBO()
  ClientTemplateBO: clientTemplate = new clientTemplate()
  employeeTemplateBO: employeeTemplate = new employeeTemplate()
  fp: functionpermission = new functionpermission()

  statusList: any = [];
  public TemplateList = []

  emit_boolean = false
  agencycheck: false

  constructor(public DataService: AgreementTemplateService, public clientservice: ClientHttpService, public global: GlobalComponent, private toast: ToastrService) {
    this.global.checkforlogout();
    this.data = DataService;
  }

  ngOnInit(): void {
    if (
      (this.global.globalAgencyId == null ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") && (this.global.agencyCode == 'SUPERADMIN')) {
      return;
    }

    this.getStatus();
    this.gettemplatetype();
    this.pageSettings = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.filterOption = {
      type: "Menu",
    };
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "AgreementTemplate");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.DataService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  createagreement() {
    this.ClientTemplateBO.datalist = ''
    this.ClientTemplateBO.templateToOnboard = true;
    this.emit_boolean = true;
    this.employeeTemplateBO.documentid = "00000000-0000-0000-0000-000000000000"
  }

  saveagreement() {

  }

  /////////////////////// Edit Template ////////////////////
  edit(data) {
    if (this.PrivatePaySelectedTab == 'Client') {
      this.ClientTemplateBO.datalist = data;
      this.ClientTemplateBO.templatename = data.templateName;
      this.ClientTemplateBO.templateToOnboard = true
      this.emit_boolean = true
    }
    else {
      this.employeeTemplateBO.datalist = data;
      this.employeeTemplateBO.templateName = data.templateName;
      this.employeeTemplateBO.documentid = data.templateId
      this.global.employeeTemplateId = data.templateId
      this.employeeTemplateBO.templateToOnboard = true
      this.emit_boolean = true
    }
  }
  //////////////////// Create Template /////////////
  create() {
    if (this.PrivatePaySelectedTab == 'Client') {
      this.ClientTemplateBO.templateToOnboard = true
      this.emit_boolean = true
    }
    else {
      this.employeeTemplateBO.templateToOnboard = true
      this.employeeTemplateBO.documentid = "00000000-0000-0000-0000-000000000000";
      this.emit_boolean = true
    }
    document.getElementById('templateNameModal').click();
  }

  dataEmitFromOnboard(value) {
    this.emit_boolean = false
    this.getOnboardTemplateList();
  }

  dataEmitAgreementEmployee(value) {
    this.emit_boolean = false
    this.getOnboardTemplateList();
  }

  getStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "STATUS");
    this.clientservice.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.statusList = data;
      this.gridTemplateBO.statusLid = this.statusList.filter(s => s.lovName == "Active")[0].id;
      this.getOnboardTemplateList();
    })
  }

  getOnboardTemplateList() {
    this.gridTemplateBO.agencyId = this.global.globalAgencyId
    this.gridTemplateBO.agencyId = (this.global.globalAgencyId != "" && this.global.globalAgencyId != null && this.global.globalAgencyId != undefined) ? this.global.globalAgencyId : "00000000-0000-0000-0000-000000000000"
    if (this.PrivatePaySelectedTab == 'Client') {
      this.DataService.executeClient(this.gridTemplateBO);
      this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
        this.gridData = data.result;
      },
        (err: any) => {
          this.toast.error(err.error.Request, "error");
        });
    }
    else {
      this.DataService.executeEmployee(this.gridTemplateBO);
      this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
        this.gridData = data.result;
      },
        (err: any) => {
          this.toast.error(err.error.Request, "error");
        });
    }
  }
  ///////////////////////template type////////////////////

  gettemplatetype() {
    let params = new URLSearchParams();
    params.append("listCode", "DOCUMENTTYPE");
    this.clientservice.getLOV(params).subscribe((data: any) => {
      this.TemplateList = data;
    })
  }

  refresh() {
    this.getOnboardTemplateList();
  }

  //........................................TAPCHANGE.......................................
  PrivatePaySelectedTab = 'Client'

  tabchange(val) {
    this.PrivatePaySelectedTab = val;

    if (this.PrivatePaySelectedTab == 'Client') {
      this.getOnboardTemplateList();

    }
    else {
      this.getOnboardTemplateList()
    }
  }

  clearName() {
    this.ClientTemplateBO.templatename = ''
    this.employeeTemplateBO.templateName = ''
    this.ClientTemplateBO.datalist = ''
    this.employeeTemplateBO.datalist = ''
  }

  dataChangeAgreement(temp) {
    let val = temp.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((temp.sorted || []).length) {
        this.gridTemplateBO.orderColumn = temp.sorted[0].name;
        this.gridTemplateBO.orderType =
          temp.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && temp.action.action != "clearFilter") {
      this.gridTemplateBO.value = temp.action.currentFilterObject.value;
      this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      this.gridTemplateBO.matchCase = temp.action.currentFilterObject.matchCase;
      this.gridTemplateBO.operator = temp.action.currentFilterObject.operator;
      if (this.gridTemplateBO.type == "number") {
        this.gridTemplateBO.value =
          temp.action.currentFilterObject.value.toString();
        this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      }
    } else {
      if (val == "filtering" && temp.action.action == "clearFilter") {
        this.gridTemplateBO.field = "agencyName";
        this.gridTemplateBO.matchCase = false;
        this.gridTemplateBO.operator = "contains";
        this.gridTemplateBO.value = "";
        this.gridTemplateBO.type = "string";
      }
    }
    this.getOnboardTemplateList();
  }

  onActionAgreement(r) {
    this.gridTemplateBO.currentpageno =
      this.grid.pagerModule.pagerObj.currentPage;
    this.gridTemplateBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (r.name == "actionBegin" && r.requestType == "filterbeforeopen") {
      this.gridTemplateBO.type = r.columnType;
    }
  }

  showColumns() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }

  showColumnsOne() {
    this.gridEmp.columnChooserModule.openColumnChooser(200, 50);
  }

  dataChangeAgreementEmp(temp) {
    let val = temp.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((temp.sorted || []).length) {
        this.gridTemplateBO.orderColumn = temp.sorted[0].name;
        this.gridTemplateBO.orderType =
          temp.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && temp.action.action != "clearFilter") {
      this.gridTemplateBO.value = temp.action.currentFilterObject.value;
      this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      this.gridTemplateBO.matchCase = temp.action.currentFilterObject.matchCase;
      this.gridTemplateBO.operator = temp.action.currentFilterObject.operator;
      if (this.gridTemplateBO.type == "number") {
        this.gridTemplateBO.value =
          temp.action.currentFilterObject.value.toString();
        this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      }
    } else {
      if (val == "filtering" && temp.action.action == "clearFilter") {
        this.gridTemplateBO.field = "agencyName";
        this.gridTemplateBO.matchCase = false;
        this.gridTemplateBO.operator = "contains";
        this.gridTemplateBO.value = "";
        this.gridTemplateBO.type = "string";
      }
    }
    this.getOnboardTemplateList();

  }

  onActionAgreementEmp(r) {
    this.gridTemplateBO.currentpageno =
    this.gridEmp.pagerModule.pagerObj.currentPage;
    this.gridTemplateBO.pageitem = this.gridEmp.pagerModule.pagerObj.pageSize;
    if (r.name == "actionBegin" && r.requestType == "filterbeforeopen") {
      this.gridTemplateBO.type = r.columnType;
    }
  }
}





